import React from "react";

const Focus = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-music2"
    >
      <circle cx="8" cy="18" r="4"></circle>
      <path d="M12 18V2l7 4"></path>
    </svg>
  );
};

export default Focus;
